<template>
  <div class="container" v-if="!$store.state.hasInternet">
    <div class="title">
      {{ $t("personalArea.extExplainOnMefBuy.didYouKnow") }}
    </div>
    <div>
      {{ $t("personalArea.extExplainOnMefBuy.buyAndUse") }}
    </div>
    <div style="padding: 10px">
      <div class="inner-msg">
        <p style="text-align: initial">
          {{ $t("personalArea.extExplainOnMefBuy.howItWorks") }}
        </p>
        <ol>
          <li>{{ $t("personalArea.extExplainOnMefBuy.step1") }}</li>
          <li>{{ $t("personalArea.extExplainOnMefBuy.step2") }}</li>
          <li>
            <b>{{ $t("personalArea.extExplainOnMefBuy.step3") }}</b>
          </li>
        </ol>
      </div>
    </div>
    <div style="font-size: 9px">
      {{ $t("personalArea.extExplainOnMefBuy.fromVer") }}
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.container {
  border-radius: 5px;
  background: #a7610f;
  color: white;
  text-align: center;
  line-height: 120%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 10px;
  margin-bottom: 15px !important;
}
.container * {
  margin: 0px;
}
.title {
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  text-align: center;
}
.inner-msg {
  background: rgba(255, 255, 255, 0.2);
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.inner-msg ol {
  list-style-position: inside;
  display: flex;
  flex-direction: column;
  text-align: right;
  padding: 5px;
}
li {
  font-size: 11px;
  line-height: 120%;
}
</style>
